import Head from "next/head"
import DefaultLayout from "@/components/DefaultLayout"
import SliderBarLeft from "@/components/SliderBarLeft"
import SliderBarRight from "@/components/SliderBarRight"
import ShopInfo from "@/components/ShopInfo"
import styles from "@/styles/article/return-policy.module.scss"
import Link from 'next/link'
export default function WarrantyPolicy() {

  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta
          name="description"
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>

      <DefaultLayout notStickyNavbar={true}>
        <div className={`${styles['page-return-policy']} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          <div className={styles["shop-info-box"]}>
            <ShopInfo hiddenContactus={true}></ShopInfo>
          </div>

          <div className={styles['content']}>
            <div className={styles['content-title']}>Warranty Policy</div>
            
            <div className={`${styles['ask-title']}`}>Statutory Conditions and Warranties</div>
            <div className={styles['answer-desc']}>
              CrazySales provides a voluntary warranty and applies the Conditions and Warranties required by law.
            </div>
            <div className={styles['answer-desc']}>
              Statutory Conditions and Warranties For all products sold by CrazySales provide conditions and warranties contained in the Commonwealth Competition and Consumer Act 2010.
            </div>
            <div className={styles['answer-desc']}>
              Where the 30 Day Change-of-Mind Period has elapsed and the conditions provide that unless the product has defects which CrazySales specifically bring to your attention before the sale, the product is of merchantable quality — that is, the product is free from manufacturing defects and faults and reaches a basic level of quality given the price of the product and description that is provided with the product. The product is fit for the purpose or job for which it is normally supplied or to which CrazySales agreed before the sale. The product matches any description provided on our website or labelling or packaging (See &quot;Changes to Product&quot;); and you receive a clear title to the product.
            </div>
            <div className={styles['answer-desc']}>
              The warranties provide that the product is clear of finance or encumbrances; and you will have free title to the product.
            </div>
            <div className={styles['answer-desc']}>
              If the product does not fulfil any of these conditions or warranties then, provided that the claim is made within a reasonable period after the sale, you may be entitled, at your discretion, to a refund, replacement of the product or to have it repaired. A reasonable period depends on the circumstances of each sale including but not limited to the nature, quality and price of the product.
            </div>
            <div className={styles['answer-desc']}>
              Any refund agreed to may be less than the purchase price depending on any use or consumption of the product which has occurred or any contribution that used by you has made to the cause of the claim.
            </div>
            <div className={styles['answer-desc']}>
              Customer Service will consider each claim on its merits on a case-by-case basis and, if required, will negotiate a solution that is acceptable to CrazySales and you including any costs involved.
            </div>
            <div className={styles['answer-desc']}>
              For more information about your rights as a consumer, see the ACCC website at&nbsp;
              <Link
                href="www.accc.gov.au"
                legacyBehavior
              >
                <a className={styles['link']} rel="noopener noreferrer">
                  www.accc.gov.au
                </a>
              </Link>
              &nbsp;or download a free copy of the Warranties and Refunds Guide at&nbsp;
              <Link
                href="https://www.accc.gov.au/consumers/consumer-rights-guarantees"
                legacyBehavior
              >
                <a className={styles['link']} rel="noopener noreferrer">
                  https://www.accc.gov.au/consumers/consumer-rights-guarantees
                </a>
              </Link>
              .
            </div>

            <div className={`${styles['ask-title']} padding-top-14`}>Statutory Conditions and Warranties</div>
            <div className={styles['answer-desc']}>
              We do not provide refunds, credit or exchanges if you have:
            </div>
            <div className={styles['answer-desc']}>
              Damaged the product by using it in a way it was not meant to be used. You have had a defect drawn to your attention before you purchased the product, for example, when products are clearly labelled as seconds or faulty, The 30 Day Change-of-Mind period has elapsed and the product matches the description provided on our website and is free from manufacturing defects or faults.
            </div>

            <div className={`${styles['ask-title']} padding-top-14`}>Voluntary Warranty Policy</div>
            <div className={styles['answer-desc']}>
              All products sold by CrazySales have a &quot;dead on arrival&quot; (DOA) warranty. This means that if the product is damaged during the delivery and a claim is made within 14 days from the date of dispatch, CrazySales will replace or repair the product at our discretion and our cost. If CrazySales have no further stock of the item and it cannot be repaired CrazySales will replace it with a similar product or offer you a full refund.
            </div>
            <div className={styles['answer-desc']}>
              If the damage is discovered outside the 14-day period contact Customer Service who will determine whether the circumstances are such that you can still proceed with a claim. You can take advantage of this offer for up to twelve months after the sale.
            </div>
            <div className={styles['answer-desc']}>
              This warranty does not apply to damaged packaging only and does not detract from your statutory rights.
            </div>

            <div className={`${styles['ask-title']} padding-top-14`}>Manufacturer’s Voluntary Warranty</div>
            <div className={styles['answer-desc']}>
              Many of the products supplied by CrazySales are covered by a Manufacturer’s voluntary warranty. The terms and conditions of such warranties are beyond our control and it is your choice whether to use such warranties. Where possible the time of such warranty will be shown on our website. For some products, it may be more efficient for you to contact the manufacturer rather than CrazySales. This is particularly so for electronic equipment. A manufacturer’s warranty does not detract from your statutory rights.
            </div>

            <div className={`${styles['ask-title']} padding-top-14`}>Making a Claim</div>
            <div className={styles['answer-desc']}>
              Provide us with a copy of your tax invoice or similar proof that the item was purchased from us. Describe accurately the problem you have encountered and provide evidence (e.g. a photograph) to support your claim. State whether you are requesting a replacement, repair, refund or credit.
            </div>

            <div className={`${styles['ask-title']} padding-top-14`}>Limitation of Liability</div>
            <div className={styles['answer-desc']}>
              (a) Our liability to the Customer (and any party claiming through the Customer against us) for any claim for loss or damages (including legal expenses) made in connection with the Contract (including the supply of Goods described in the Contract) whether in contract, tort (including negligence), under the statute, in equity or otherwise shall be strictly limited as follows (except to the extent that the law prohibits such a limitation):
            </div>
            <div className={styles['answer-desc']}>
              (i) for any liability arising from Goods not meeting the specification or which are said to be otherwise defective or deficient, our liability is limited to the cost of replacement of those Goods as soon as reasonably practicable, or the repair of those Goods or the repayment (or allowance) of the Purchase Price of those Goods (at the option of Our);
            </div>
            <div className={styles['answer-desc']}>
              (ii) for any liability arising from the services forming part of the Goods not meeting the scope.
            </div>

            <div className={`${styles['ask-title']} padding-top-14`}>Consequential Loss</div>
            <div className={styles['answer-desc']}>
              (a) We may hold the Customer liable, to the maximum extent permitted by law, for any indirect, special or consequential loss or damage of any nature whatsoever resulting from or caused in any way by the Goods it supplies, where indirect, special or consequential loss or damage includes:
            </div>
            <div className={styles['answer-desc']}>
              (i) any loss of income, profit, production, contract, customers, business opportunity or business;
            </div>
            <div className={styles['answer-desc']}>
              (ii) any loss of goodwill or reputation;
            </div>
            <div className={styles['answer-desc']}>
              (iii) any loss or damage resulting from the loss or damage to goods other than the Goods.
            </div>

            <div className={`${styles['ask-title']} padding-top-14`}>Defective Goods</div>
            <div className={styles['answer-desc']}>
              (a) Any claim by the Customer in respect of defective, non-conforming or damaged Goods must be made in writing within 14 days of the delivery of the Goods, unless a longer period is expressly agreed to by us in writing.
            </div>
            <div className={styles['answer-desc']}>
              (b) Despite any other provision of the Contract, we are not liable, to the maximum extent permitted by law, for:
            </div>
            <div className={styles['answer-desc']}>
              (i) the cost of removal of Goods not meeting the specification or which are said to be otherwise defective or deficient, whether installed or otherwise;
            </div>
            <div className={styles['answer-desc']}>
              (ii) the cost of installation of replacements for Goods not meeting the specification or which are said to be otherwise defective or deficient;
            </div>
            <div className={styles['answer-desc']}>
              (iii) defects or deficiencies in Goods caused by improper installation or maintenance of Goods or related components or normal wear and tear and damage.
            </div>
          </div>
        </div>
      </DefaultLayout>
    </>
  )
}